/** Orbit GET /cases `channel` code -> CRM form slug (orbitChannel). */
const ORBIT_CHANNEL_TO_FORM_TYPE: Record<string, string> = {
    WEB: 'principal',
    PHONE: 'telefonico',
    WHATSAPP: 'whatsapp',
    BACKOFFICE: 'backoffice',
    CHAT: 'chat',
    VIDEO: 'video',
    DCF: 'defensor_consumidor',
    EMAIL: 'defensor_consumidor',
};

/** CRM form slug -> Orbit POST /cases `channel`. */
const CRM_FORM_TYPE_TO_ORBIT_CHANNEL: Record<string, string> = {
    principal: 'WEB',
    telefonico: 'PHONE',
    whatsapp: 'WHATSAPP',
    backoffice: 'BACKOFFICE',
    chat: 'CHAT',
    video: 'VIDEO',
    defensor_consumidor: 'DCF',
};

const readString = (value: unknown): string => {
    if (value === undefined || value === null || value === '') {
        return '';
    }
    return String(value);
};

export const resolveCrmFormTypeToOrbitChannel = (
    formType?: string
): string | undefined => {
    const slug = formType?.trim();

    if (!slug) return undefined;

    return CRM_FORM_TYPE_TO_ORBIT_CHANNEL[slug];
};

export const resolveOrbitFormTypeFromCase = (
    orbitCase: Record<string, unknown>
): string => {
    const metadata =
        orbitCase.metadata && typeof orbitCase.metadata === 'object'
            ? (orbitCase.metadata as Record<string, unknown>)
            : undefined;

    const fromSlug =
        readString(orbitCase.orbit_channel) ||
        readString(metadata?.orbit_channel) ||
        readString(metadata?.form_type);

    if (fromSlug) return fromSlug;

    const channelCode = readString(orbitCase.channel).trim().toUpperCase();

    return ORBIT_CHANNEL_TO_FORM_TYPE[channelCode] ?? '';
};
